import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useEffect, useState } from 'react'
import { AlloyDTO, SettingsDTO } from '@ringo/shared'
import { useAlloys } from './hooks/useAlloys'
import Loader from '../components/common/Loader'
import { useSettingsApi } from './api-context'
import { LanguageKey } from '@ringo/shared'

interface IGlobalContext {
    alloys: AlloyDTO[]
    setAlloys: Dispatch<SetStateAction<AlloyDTO[]>>
    settings: SettingsDTO
    setSettings: Dispatch<SetStateAction<SettingsDTO>>
    loadedTranslations: LanguageKey[]
    setLoadedTranslations: Dispatch<SetStateAction<LanguageKey[]>>
}

export const GlobalContext = createContext<IGlobalContext>({
    alloys: [],
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setAlloys: () => {},
    settings: null!,
    setSettings: () => {},
    loadedTranslations: [],
    setLoadedTranslations: () => {},
})

export const GlobalContextProvider = ({ children }: { children: ReactNode }) => {
    const [alloys, setAlloys] = useState<AlloyDTO[]>([])
    const [settings, setSettings] = useState<SettingsDTO>(null as any)
    const [loadedTranslations, setLoadedTranslations] = useState<LanguageKey[]>([])

    return (
        <GlobalContext.Provider value={{ alloys, setAlloys, settings, setSettings, loadedTranslations, setLoadedTranslations }}>
            <GlobalContextSetter>{children}</GlobalContextSetter>
        </GlobalContext.Provider>
    )
}

const GlobalContextSetter = ({ children }: { children: ReactNode }) => {
    const { alloys, refetch: refetchAlloys } = useAlloys()
    const settingsApi = useSettingsApi()
    const { settings, setSettings } = useContext(GlobalContext)

    useEffect(() => {
        refetchAlloys()
        settingsApi.getSetting().then((response) => setSettings(response.data))
    }, [])

    return !alloys?.length || !settings ? <Loader withBackdrop></Loader> : children
}
